import { LocalDate } from '@js-joda/core';

export enum SpendingTimePeriod {
    DAY = 'day',
    MONTH = 'month',
    YEAR = 'year'
}

export class GetSpendingHistoryArgs {
    id?: string;
    timePeriod?: SpendingTimePeriod;
    startDate?: LocalDate;
    endDate?: LocalDate;
    cumulative?: boolean;
    includeTransfers?: boolean;
    enabled?: boolean;
}

export class GetSpendingSumForCategoryArgs {
    id: string;
    startDate?: string;
    endDate?: string;
    enabled?: boolean;
}

export class GetSpendingSumsArgs {
    startDate?: string;
    endDate?: string;
}

export class SpendingHistoryDataPoint {
    timePeriodStart: string;
    spent: number;
}

export class SpendingHistory {
    groupId: string;
    averageSpent: number;
    averageSpentPercent: number;
    history: SpendingHistoryDataPoint[];
}
